import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-card-promotion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-promotion.component.html',
  styleUrl: './card-promotion.component.scss'
})
export class CardPromotionComponent {
  @Input() destacado: boolean = false;
  @Input() icono :string= ''
  @Input() title : string=''
  @Input () subTitle : string =''
  @Input() text: string =''
  @Input() buttonText: string ='' 
  }
